/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './backupPicker/backupPicker.js';
import './basicpicker/basicpicker.js';
import './batchrangepicker/batchrangepicker.js';
import './checkboxButton/checkboxButton.js';
import './daterangepicker/daterangepicker.js';
import './wizardProgress/wizardProgress.js';
import './dropdown/dropdown.js';
import './header/header.js';
import './invalidConfig/invalidConfig.js';
import './kbLink/kbLink.js';
import './maintenanceMode/MaintenanceMode.js';
import './mask/mask.js';
import './maskWithDashboardButton/maskWithDashboardButton.js';
import './modal/modals.js';
import './paging/paging.js';
import './picker/picker.js';
import './progress/progress.js';
import './radioButton/radioButton.js';
import './receiptInfo/receiptInfo.js';
import './selectList/selectList.js';
import './uploadcsvpicker/uploadcsvpicker.js';
import './uploadcsv/uploadcsv.js';
import './userdropdown/userdropdown.js';
import './supportdropdown/supportdropdown.js';
import './wizard/Module.js';
import './filters/filters.js';
import './childObjects';
import './expandButton';
import './listChildObjects';

/**
 * Grouping module used for including all shared sub-modules.
 */
angular.module('sbsf.shared', [
  'shared.backupPicker',
  'shared.basicpicker',
  'shared.batchrangepicker',
  'shared.checkboxButton',
  'shared.daterangepicker',
  'shared.wizardProgress',
  'shared.dropdown',
  'shared.header',
  'shared.invalidConfig',
  'shared.kbLink',
  'shared.maintenanceMode',
  'shared.mask',
  'shared.maskWithDashboardButton',
  'shared.modal',
  'shared.paging',
  'shared.picker',
  'shared.progress',
  'shared.radioButton',
  'shared.receiptInfo',
  'shared.selectList',
  'shared.uploadCSVPicker',
  'shared.uploadCSV',
  'shared.userdropdown',
  'shared.supportdropdown',
  'shared.wizard',
  'shared.filters',
  'shared.childObjects',
  'shared.listChildObjects',
  'shared.expandButton'
]);
